import type { ChamadoResponse } from '@/api/generated/model';
import { FormularioDeChamado } from '@/features/suporte/components/FormularioDeChamado';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog';

/**
 * `<Dialog>` em volta do `FormularioDeChamado` — usado pelo botão "Abrir
 * chamado" das telas. O painel do botão flutuante renderiza o MESMO formulário
 * inline, sem este invólucro.
 */
export function NovoChamadoDialogo({
  aberto,
  aoFechar,
  aoAbrirChamado,
}: {
  aberto: boolean;
  aoFechar: () => void;
  aoAbrirChamado?: (chamado: ChamadoResponse) => void;
}) {
  return (
    <Dialog open={aberto} onOpenChange={(v) => !v && aoFechar()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Abrir chamado de suporte</DialogTitle>
          <DialogDescription>
            Conte o que está acontecendo. A conversa continua aqui dentro da plataforma.
          </DialogDescription>
        </DialogHeader>

        <FormularioDeChamado
          aoCancelar={aoFechar}
          aoConcluir={(chamado) => {
            aoFechar();
            aoAbrirChamado?.(chamado);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
